import "../professionalBio/professionalBio.css";

const TiffanyBioContent = (
  <div className="info-box-style">
    <p>
      Hey, hey! I'm Tiffany.
      <br />
      <br />
      I am a Licensed Professional Counselor with over 15 years of clinical
      experience. I am a Certified Professional Clinical Supervisor, Certified
      Holistic Therapist, and EMDR Certified provider. I am Certified in the{" "}
      <a
        href="https://traumaconsciousyoga.com/"
        target="_blank"
        rel="noreferrer"
      >
        Trauma Conscious Yoga Method
      </a>{" "}
      and I'm also known as The Cookie Counselor. Yep, I bake to release stress,
      ground myself, and enrich my creative sweets passion.
      <br />
      <br />
      If you're feeling overwhelmed by anxiety, weighed down by past experiences,
      struggling with self-worth, navigating grief, or finding it difficult to
      move forward after trauma, you don't have to face it alone.
      <br />
      <br />
      I am committed to providing a safe, supportive, and nonjudgmental space
      where you can feel heard, understood, and empowered throughout your healing
      journey.
      <br />
      <br />
      Throughout my career, I have had the privilege of serving individuals in a
      variety of clinical settings, helping clients navigate life's most
      challenging experiences.
      <br />
      <br />
      I am passionate about supporting individuals as they heal from sexual
      trauma, process traumatic experiences, manage anxiety and depression,
      strengthen self-esteem, and work through grief and loss.
      <br />
      <br />
      With cultural humility at the foundation of my work, I utilize integrative
      and holistic approaches within a trauma-informed, person-centered
      framework.
      <br />
      <br />
      Together, we will explore the challenges that may be holding you back,
      build on your strengths, and create meaningful steps toward healing and
      growth.
      <br />
      <br />
      You deserve compassionate support as you release the weight of the past,
      restore your sense of self, and redefine what coming alive looks like for
      you.
    </p>
  </div>
);

export default TiffanyBioContent;
